/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Jinhyoung Jang (jangjh@rsupport.com)
 *
 * @description
 *
 * @created at 2024-06-26 15:59:33
 **/

import { useEffect } from "react";
import { EventHandler } from "@rfice/eventhandler";
import { useAtom } from "jotai";

import { stateOnlineAtom } from "./atom";

const LOGTAG = "#useOnlineMonitor#";

export default function useOnlineMonitor() {
	const [stateOnline, setState] = useAtom(stateOnlineAtom);

	useEffect(() => {
		window.ononline = async () => {
			console.debug(LOGTAG, "Network online");

			setState(true);
			EventHandler.fire("$Network::Online$", true);
		};

		window.onoffline = () => {
			console.debug(LOGTAG, "Network offline");

			setState(false);
			EventHandler.fire("$Network::Online$", false);
		};
	});

	return stateOnline;
}
